

// // // import React from "react";
// // // import { Box, Typography, Icon, Paper } from "@mui/material";
// // // import { clsx } from "clsx";
// // // import { useNavigate } from "react-router-dom";
// // // const StautusCardForSuperAdmin = ({ subheader1, subheader2, icon, value1, value2, value, header, total_referral, total_registration, Diamonds, Ruby, self, operator, componentPath }) => {
// // //   const color = "blue";
// // //   const hov = "red";
// // //   const navigate=useNavigate()

// // //   return (
// // //     <Paper
// // //       onClick={()=>navigate(componentPath)}
// // //       sx={{
// // //         padding: 1,
// // //         backgroundColor: "white",
// // //         borderRadius: 2,
// // //         boxShadow: 3,
// // //         cursor:'pointer'

// // //       }}
// // //     >

// // //       <Box sx={{
// // //         display: 'flex', justifyContent: "space-between",
// // //         // alignItems:'center'
// // //       }}>
// // //         <Typography variant="subtitle2" sx={{ fontSize: "13px", color: "#C38F51" }} >
// // //           {header}
// // //         </Typography>
// // //         <Box sx={{ border: "1px solid #C38F51", borderRadius: "5px", background: "#C38F51", height: "40px", width: "40px", display: "flex", justifyContent: "center", alignItems: "center" }}>
// // //           <Box
// // //             component='img'
// // //             src={icon}
// // //           >

// // //           </Box>
// // //         </Box>

// // //       </Box>

// // //       {total_referral && (
// // //         // <Box sx={{ display: "flex", justifyContent: "start" }}>

// // //         <Box sx={{ display: "flex", justifyContent: "start" }}>


// // //           <Box sx={{ display: "flex", justifyContent: "space-between" }}>
// // //             <Typography variant="subtitle1" fontSize="17px" color="gray">{subheader1}
// // //               <span style={{ fontSize: "20px", paddingLeft: "5px", fontWeight: "800", color: "black" }}>{value1} </span>
// // //             </Typography>
// // //             {/* <Typography variant="body2" color="#C38F51" mt={0.5}>
// // //               <span style={{ fontSize: "18px", color: "black", fontWeight: "800" }}>{Diamonds} </span>
// // //             </Typography> */}
// // //           </Box>
// // //           <Box sx={{ display: "flex", justifyContent: "space-between" }}>

// // //             <Typography variant="subtitle1" fontSize="17px" color="gray" ml={4}>{subheader2}
// // //               <span style={{ fontSize: "20px", paddingLeft: "5px", fontWeight: "800", color: "black" }}>{value2} </span>
// // //             </Typography>
// // //             {/* <Typography variant="body2" color="#C38F51" mt={0.5}>
// // //               <span style={{ fontSize: "18px", color: "black", fontWeight: "800" }}>{Ruby} </span>
// // //             </Typography> */}

// // //           </Box>

// // //         </Box>
// // //         // </Box>

// // //       )}

// // //       <Typography variant="body2" color="#C38F51" mt={0.5}>
// // //         <span style={{ fontSize: "25px", color: "black", fontWeight: "800" }}>{value} </span>
// // //       </Typography>
// // //     </Paper>
// // //   );
// // // };

// // // export default StautusCardForSuperAdmin;




// // import React from "react";
// // import { Box, Typography, Paper } from "@mui/material";
// // import { useNavigate } from "react-router-dom";

// // const StautusCardForSuperAdmin = ({ icon, header, dataArray, componentPath }) => {
// //   const navigate = useNavigate();

// //   return (
// //     <Paper
// //       onClick={() => navigate(componentPath)}
// //       sx={{
// //         padding: 1,
// //         backgroundColor: "white",
// //         borderRadius: 2,
// //         boxShadow: 3,
// //         cursor: "pointer",
// //       }}
// //     >
// //       {/* Header Section */}
// //       <Box sx={{ display: "flex", justifyContent: "space-between" }}>
// //         <Typography variant="subtitle2" sx={{ fontSize: "13px", color: "#C38F51" }}>
// //           {header}
// //         </Typography>
// //         <Box
// //           sx={{
// //             border: "1px solid #C38F51",
// //             borderRadius: "5px",
// //             background: "#C38F51",
// //             height: "40px",
// //             width: "40px",
// //             display: "flex",
// //             justifyContent: "center",
// //             alignItems: "center",
// //           }}
// //         >
// //           <Box component="img" src={icon} />
// //         </Box>
// //       </Box>

// //       {/* Dynamic Data Section with Horizontal Scroll */}
// //       {dataArray?.length > 0 && (
// //         <Box
// //           sx={{
// //             display: "flex",
// //             overflowX: "auto",
// //             gap: 2,
// //             padding: "8px 0",
// //             whiteSpace: "nowrap",
// //             scrollbarWidth: "thin", // Firefox
// //             "&::-webkit-scrollbar": {
// //               height: "5px",
// //             },
// //             "&::-webkit-scrollbar-thumb": {
// //               background: "#C38F51",
// //               borderRadius: "10px",
// //             },
// //           }}
// //         >
// //           {dataArray.map((item, index) => (
// //             <Box key={index} sx={{ display: "flex", flexDirection: "row", minWidth: "80px" }}>
// //               <Typography variant="subtitle1" fontSize="15px" color="gray">
// //                 {item.label}
// //               </Typography>
// //               <Typography variant="body2" fontSize="18px" fontWeight="800" color="black">
// //                 {item.value}
// //               </Typography>
// //             </Box>
// //           ))}
// //         </Box>
// //       )}
// //     </Paper>
// //   );
// // };

// // export default StautusCardForSuperAdmin;




// import React, { useRef } from "react";
// import { Box, Typography, Paper, IconButton } from "@mui/material";
// import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
// import { useNavigate } from "react-router-dom";

// const StautusCardForSuperAdmin = ({ icon, header, dataArray, componentPath }) => {
//   const navigate = useNavigate();
//   const scrollRef = useRef(null);

//   // Function to scroll left
//   const handlePrev = () => {
//     if (scrollRef.current) {
//       scrollRef.current.scrollBy({ left: -120, behavior: "smooth" });
//     }
//   };

//   // Function to scroll right
//   const handleNext = () => {
//     if (scrollRef.current) {
//       scrollRef.current.scrollBy({ left: 120, behavior: "smooth" });
//     }
//   };

//   return (
//     <Paper
//       onClick={() => navigate(componentPath)}
//       sx={{
//         padding: 2,
//         backgroundColor: "white",
//         borderRadius: 2,
//         boxShadow: 3,
//         cursor: "pointer",
//         position: "relative",
//         overflow: "hidden",
//       }}
//     >
//       {/* Header Section */}
//       <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//         <Typography variant="subtitle2" sx={{ fontSize: "13px", color: "#C38F51" }}>
//           {header}
//         </Typography>
//         <Box
//           sx={{
//             border: "1px solid #C38F51",
//             borderRadius: "5px",
//             background: "#C38F51",
//             height: "40px",
//             width: "40px",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//           }}
//         >
//           <Box component="img" src={icon} />
//         </Box>
//       </Box>

//       {/* Scrollable Section with Arrows */}
//       {dataArray?.length > 0 && (
//         <Box sx={{ display: "flex", alignItems: "center", mt: 1, position: "relative" }}>
//           {/* Left Scroll Button - Show only if more than 2 items */}
//           {dataArray.length > 2 && (
//             <IconButton
//               onClick={handlePrev}
//               sx={{
//                 position: "absolute",
//                 left: 0,
//                 zIndex: 2,
//                 backgroundColor: "rgba(255, 255, 255, 0.8)",
//                 "&:hover": { backgroundColor: "#f0f0f0" },
//               }}
//             >
//               <ArrowBackIos fontSize="small" />
//             </IconButton>
//           )}

//           {/* Scrollable Content */}
//           <Box
//             ref={scrollRef}
//             sx={{
//               display: "flex",
//               overflowX: "auto",
//               scrollBehavior: "smooth",
//               gap: 2,
//               padding: "8px 40px", // Space for buttons
//               whiteSpace: "nowrap",
//               flexGrow: 1,
//               scrollbarWidth: "none", // Hide scrollbar for better UI
//               "&::-webkit-scrollbar": { display: "none" },
//               maxWidth: "240px", // Show only 2 items
//             }}
//           >
//             {dataArray.map((item, index) => (
//               <Box key={index} sx={{ minWidth: "100px", textAlign: "center" ,display:'flex'}}>
//                 <Typography variant="subtitle1" fontSize="15px" color="gray">
//                   {item.label}
//                 </Typography>
//                 <Typography variant="body2" fontSize="18px" fontWeight="800" color="black">
//                   {item.value}
//                 </Typography>
//               </Box>
//             ))}
//           </Box>

//           {/* Right Scroll Button - Show only if more than 2 items */}
//           {dataArray.length > 2 && (
//             <IconButton
//               onClick={handleNext}
//               sx={{
//                 position: "absolute",
//                 right: 0,
//                 zIndex: 2,
//                 backgroundColor: "rgba(255, 255, 255, 0.8)",
//                 "&:hover": { backgroundColor: "#f0f0f0" },
//               }}
//             >
//               <ArrowForwardIos fontSize="small" />
//             </IconButton>
//           )}
//         </Box>
//       )}
//     </Paper>
//   );
// };

// export default StautusCardForSuperAdmin;


import React, { useRef, useState, useEffect } from "react";
import { Box, Typography, Paper, IconButton } from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const StautusCardForSuperAdmin = ({ icon, header, dataArray, componentPath }) => {
  const navigate = useNavigate();
  const scrollRef = useRef(null);
  const [showPrev, setShowPrev] = useState(false);
  const [showNext, setShowNext] = useState(dataArray?.length > 2);

  useEffect(() => {
    const handleScroll = () => {
      if (scrollRef.current) {
        setShowPrev(scrollRef.current.scrollLeft > 0);
        setShowNext(
          scrollRef.current.scrollLeft + scrollRef.current.clientWidth < scrollRef.current.scrollWidth
        );
      }
    };

    if (scrollRef.current) {
      scrollRef.current.addEventListener("scroll", handleScroll);
      handleScroll(); // Initialize visibility
    }

    return () => {
      if (scrollRef.current) {
        scrollRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, [dataArray?.length]);

  const handlePrev = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -120, behavior: "smooth" });
    }
  };

  const handleNext = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 120, behavior: "smooth" });
    }
  };

  return (
    <Paper
      onClick={() => navigate(componentPath)}
      sx={{
        padding: 2,
        backgroundColor: "white",
        borderRadius: 2,
        boxShadow: 3,
        cursor: "pointer",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Header Section */}
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography variant="subtitle2" sx={{ fontSize: "13px", color: "#C38F51" }}>
          {header}
        </Typography>
        <Box
          sx={{
            border: "1px solid #C38F51",
            borderRadius: "5px",
            background: "#C38F51",
            height: "40px",
            width: "40px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box component="img" src={icon} />
        </Box>
      </Box>

      {/* Scrollable Section with Arrows */}
      {dataArray?.length > 0 && (
        <Box sx={{ display: "flex", alignItems: "center", mt: 1, position: "relative" }}>
          {/* Left Scroll Button (Show only if scrolled past first item) */}
          {showPrev && (
            <IconButton
              onClick={handlePrev}
              sx={{
                position: "absolute",
                left: 0,
                zIndex: 2,
                backgroundColor: "rgba(255, 255, 255, 0.8)",
                "&:hover": { backgroundColor: "#f0f0f0" },
              }}
            >
              <ArrowBackIos style={{fontSize:'10px'}} />
            </IconButton>
          )}

          {/* Scrollable Content */}
          <Box
            ref={scrollRef}
            sx={{
              display: "flex",
              overflowX: "auto",
              scrollBehavior: "smooth",
              gap: 2,
            //   padding: "8px 40px", // Space for buttons
              whiteSpace: "nowrap",
              flexGrow: 1,
              scrollbarWidth: "none",
              "&::-webkit-scrollbar": { display: "none" },
              maxWidth: "240px", // Show only 2 items initially
            }}
          >
            {dataArray?.map((item, index) => (
              <Box key={index} sx={{ minWidth: "100px", textAlign: "center" ,display:"flex"}}>
                <Typography variant="subtitle1" fontSize="15px" color="gray" marginRight={1}>
                  {item.label}
                </Typography>
                <Typography variant="body2" fontSize="18px" fontWeight="800" color="black">
                  {item.value}
                </Typography>
              </Box>
            ))}
          </Box>

          {/* Right Scroll Button (Show only if there’s more content to scroll) */}
          {showNext && (
            <IconButton
              onClick={handleNext}
              sx={{
                position: "absolute",
                right: 0,
                zIndex: 2,
                backgroundColor: "rgba(255, 255, 255, 0.8)",
                "&:hover": { backgroundColor: "#f0f0f0" },
              }}
            >
              <ArrowForwardIos style={{fontSize:'10px'}} />
            </IconButton>
          )}
        </Box>
      )}
    </Paper>
  );
};

export default StautusCardForSuperAdmin;
